import { render, staticRenderFns } from "./StoreroomEditComponent.vue?vue&type=template&id=34f89a84"
import script from "./StoreroomEditComponent.vue?vue&type=script&lang=js"
export * from "./StoreroomEditComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreroomEditComponent.vue?vue&type=style&index=0&id=34f89a84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports